<script setup lang="ts">
import type { Property } from '~/core/entities/property';

import { formatOpenHouseSchedule } from '~/core/entities/property/OpenHouse';

import { GraphicsTriangle } from '~/components/GraphicsTriangle';

import DoorOpenIcon from '~icons/material-symbols-light/door-open-sharp';

import PropertyCardTag from './PropertyCardTag.vue';

const props = withDefaults(
	defineProps<{
		property: Pick<Property, 'openHouses' | 'isExclusive'>;
		isPropertyActive: boolean;
		isExclusive?: boolean;
	}>(),
	{ isExclusive: undefined }
);

const openHouse = computed(() => props.property.openHouses?.[0]);
const schedule = computed(() =>
	openHouse.value
		? formatOpenHouseSchedule(openHouse.value, { compact: true })
		: ''
);
const showExclusive = computed(
	() =>
		props.isPropertyActive && (props.isExclusive ?? props.property.isExclusive)
);
</script>

<template>
	<div
		v-if="!isPropertyActive || showExclusive || openHouse"
		class="pointer-events-none absolute left-3 right-16 top-3 z-30 flex flex-wrap items-start gap-2"
		data-testid="property-card-tags"
	>
		<PropertyCardTag v-if="!isPropertyActive" data-testid="inactive-badge">
			Indisponível
		</PropertyCardTag>
		<PropertyCardTag v-else-if="showExclusive" data-testid="exclusive-badge">
			<template #icon>
				<span
					class="flex size-4 shrink-0 items-center justify-center"
					aria-hidden="true"
				>
					<GraphicsTriangle stroke="white" class="size-3" />
				</span>
			</template>
			Exclusivo
		</PropertyCardTag>
		<PropertyCardTag v-if="openHouse" data-testid="open-house-badge">
			<template #icon>
				<DoorOpenIcon
					class="size-4 shrink-0 text-white-dark-3"
					aria-hidden="true"
				/>
			</template>
			Open House · {{ schedule }}
		</PropertyCardTag>
	</div>
</template>
